<template>
    <div class="item" @click="jumpToDetail">
        <div class="img">
            <img :src="info.imgs[0]" v-lazy="info.imgs[0]" width="100%">
            <!-- <img src="../../../public/img/1.jpg" width="100%"> -->
        </div>
        <h2>{{info.itemNo}}</h2>
        <p>{{info.desc}}</p>
        <b>FOB price: {{info.price}}</b>
        <b>MOQ: {{info.qty}}</b>
    </div>
</template>

<script>
export default {
    name: 'ProductItem',
    props: {
        info: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        jumpToDetail() {
            this.$router.push({
                name: "productDetail",
                query: this.info
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .item { display: inline-block; width: 100%; }
    .item .img { width: 100%; height: 0; background-color: #f7f8fa; padding-bottom: 100%; position: relative; }
    .item .img img { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); }
    .item h2 { background: #dddddd; color: #4c4848; line-height: 1.5rem; margin: .2rem 0 .5rem; }
    .item p { overflow:hidden; word-break: break-all; text-overflow:ellipsis; display: -webkit-box; -webkit-box-orient:vertical; -webkit-line-clamp:2; margin-bottom: 4px; }
    .item b { display: block; margin-top: 4px; }
</style>